import React, { useEffect } from 'react';
import { useStateValue } from './state';
import { Route } from 'react-router-dom';
import axios from 'axios';
// import { jwtDecode } from 'jwt-decode'; // Default import
import KeycloakProvider, { configureKeycloak, getKeycloak, Login, Logout } from 'react-router-keycloak';
import CustomLogout from './components/CustomLogout';
const constants = require('./constants.json');

// Configure Keycloak with server URL, realm, and client ID.
configureKeycloak(process.env.REACT_APP_AUTH_SERVER_URL, constants.KEYCLOAK_REALM, constants.KEYCLOAK_CLIENT_ID);

// Get the shared Keycloak instance.
const kc = getKeycloak();

if (kc) {
  kc.updateToken = (minValidity) => {
    // console.log('Prevented refresh with minValidity:', minValidity);
    return Promise.resolve(false);
  };

  kc.onTokenExpired = () => {
    console.log('Token expired event fired. Not refreshing.');
  };
}

// Optional: A helper function to check token validity.
// const isTokenValid = (token) => {
//   try {
//     const decoded = jwtDecode(token);
//     const currentTime = Date.now() / 1000;
//     return decoded.exp > currentTime;
//   } catch (error) {
//     return false;
//   }
// };

// Callback to handle token refresh events (if ever called).
const handleTokenRefresh = (token, dispatch) => {
  // Update state and localStorage with the token.
  dispatch({ type: 'STORE_STRING', payload: token });
  localStorage.setItem('authToken', token);
};

// Function to store user info and token upon successful login.
const storeUserAndAuthHeaders = (dispatch) => {
  if (kc.tokenParsed && kc.tokenParsed.preferred_username) {
    dispatch({
      type: 'ADD_USER',
      payload: {
        user: kc.tokenParsed.preferred_username,
        locationId:
          kc.tokenParsed.location === 'lv'
            ? 1
            : kc.tokenParsed.location === 'os'
            ? 2
            : kc.tokenParsed.location === 'hi'
            ? 5
            : kc.tokenParsed.location === 'ny'
            ? 7
            : kc.tokenParsed.location === 'de'
            ? 4
            : 1,
        roles: kc.tokenParsed.realm_access.roles,
      },
    });
  } else {
    dispatch({
      type: 'ADD_USER',
      payload: { user: '', location: '' },
    });
  }
  dispatch({ type: 'STORE_STRING', payload: kc.token });
  localStorage.setItem('authToken', kc.token);
  localStorage.setItem('authTokenParsed', JSON.stringify(kc.tokenParsed));
  localStorage.setItem('authRefreshToken', kc.refreshToken);
  localStorage.setItem('refreshTokenParsed', JSON.stringify(kc.refreshTokenParsed));
  localStorage.setItem('idToken', kc.idToken);
  localStorage.setItem('idTokenParsed', JSON.stringify(kc.idTokenParsed));
};

const AuthorizationProvider = ({ children }) => {
  const [, dispatch] = useStateValue();

  useEffect(() => {
    if (kc) {
      // Initialize Keycloak and disable the iframe check.
      kc.init({
        token: localStorage.getItem('authToken'),
        refreshToken: localStorage.getItem('authRefreshToken'),
        idToken: localStorage.getItem('idToken'),
        idTokenParsed: JSON.parse(localStorage.getItem('idTokenParsed')),
        refreshTokenParsed: JSON.parse(localStorage.getItem('refreshTokenParsed')),
        tokenParsed: JSON.parse(localStorage.getItem('authTokenParsed')),

        checkLoginIframe: true,
      })
        .then((authenticated) => {
          // console.log('Keycloak initialized:', kc);
        })
        .catch((err) => console.error('Keycloak initialization error:', err));
    }

    // console.log('refresh token', localStorage.getItem('authRefreshToken'));
  }, []);

  // Set up an axios interceptor to attach the token on every request.
  axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      // console.log('localStorageToken', token);
      config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
  });

  return (
    <KeycloakProvider
      loginPath="/login"
      logoutPath="/logout"
      onRefresh={(token) => handleTokenRefresh(token, dispatch)}>
      <Route
        path="/login"
        render={(props) => <Login onSuccess={() => storeUserAndAuthHeaders(dispatch)} redirectTo="/" {...props} />}
      />
      <Route path="/logout" render={(props) => <CustomLogout {...props} />} />
      {children}
    </KeycloakProvider>
  );
};

export default AuthorizationProvider;
